<template>
<div class="chapter">
<div class="inner_page">
<div id="cov">
<img alt="image" src="OEBPS/images/9780805076882.jpg" style="height:100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?4b716ec9